import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

// Flattened helper arrays
const EMAIL_TEMPLATE_TYPES = [
  { value: "", label: "Select" },
  {
    value: "INDIVIDUAL_REGISTRATION_SUCCESSFUL",
    label: "Individual Registration Successful",
  },
  {
    value: "CORPORATE_REGISTRATION_SUCCESSFUL",
    label: "Corporate Registration Successful",
  },
  {
    value: "TRADER_CHANNEL_PARTNERS_REGISTRATION_SUCCESSFUL",
    label: "Trader/Channel Partners Registration Successful",
  },
  { value: "PASSOWRD_RESET", label: "Password Reset" },
  { value: "EMAIL_VERIFICATION", label: "Email Verification" },
  { value: "OTPCODE", label: "OTP Code" },
];

const ACTIVE_STATUS_OPTIONS = [
  { value: "", label: "Select" },
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
];

export default class EmailTemplateSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,valid:false,
      msg: "",
      toastColor: "",
      emailTemplates: [],
      template: {
        id: 0,
        emailTemplateType: "INDIVIDUAL_REGISTRATION_SUCCESSFUL",
        subject: "",
        templateData: "",
        activeStatus: "YES",
      },
      editing: false,
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchTemplates = this.fetchTemplates.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    this.fetchTemplates(token);
  }

  fetchTemplates(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/settings/getallemailtemplates", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const templates = Array.isArray(response.data) ? response.data : [];
        this.setState({
          emailTemplates: templates,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          emailTemplates: [],
          loading: false,
          error:
            error?.response?.data?.message || "Failed to load email templates.",
          msg:
            error?.response?.data?.message || "Failed to load email templates.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState(
      (prevState) => ({
        template: { ...prevState.template, [name]: value },
      }),
      this.validate
    );
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (this.state.editing) {
      // Explicit validation
      if (
        !s.template.emailTemplateType ||
        s.template.emailTemplateType.trim() === ""
      ) {
        errors.emailTemplateType = "Template type is required";
        valid = false;
      }
      if (!s.template.subject || s.template.subject.trim() === "") {
        errors.subject = "Subject is required";
        valid = false;
      }
      if (!s.template.templateData || s.template.templateData.trim() === "") {
        errors.templateData = "Template data is required";
        valid = false;
      }
      if (!s.template.activeStatus || s.template.activeStatus.trim() === "") {
        errors.activeStatus = "Active status is required";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = { ...this.state.template };

    const self = this;
    axios
      .post(API + "/settings/emailtemplatesave", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "Email template saved successfully!",
            toastColor: "success",
            loading: false,
          });
          // Reset form
          self.setState({
            template: {
              id: 0,
              emailTemplateType: "INDIVIDUAL_REGISTRATION_SUCCESSFUL",
              subject: "",
              templateData: "",
              activeStatus: "YES",
            },
            editing: false,
            errors: {},
          });
          // Refetch data
          self.fetchTemplates(token);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save email template.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save email template. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(template) {
    this.setState(
      {
        template: { ...template },
        editing: true,
      },
      this.validate
    );
  }

  handleCancelEdit() {
    this.setState({
      template: {
        id: 0,
        emailTemplateType: "INDIVIDUAL_REGISTRATION_SUCCESSFUL",
        subject: "",
        templateData: "",
        activeStatus: "YES",
      },
      editing: false,
      errors: {},
    });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen h-dvh flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Email Template Settings" />
          {divMsg}
          <div className="w-full grow px-5 h-[60%]">
            {s.editing ? (
              // Edit/Add Form
              <form
                className="flex flex-col items-center w-full mt-2 pt-3 pb-2 h-full overflow-y-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="grid grid-cols-2 gap-x-8 gap-y-4 max-w-5xl mx-auto">
                  <div className="input-group">
                    <label className="input-group-text">Template Type</label>
                    <select
                      name="emailTemplateType"
                      className={`form-control ${
                        s.errors.emailTemplateType ? " !border-red-500" : ""
                      }`}
                      value={s.template.emailTemplateType}
                      onChange={this.handleChange}
                      required
                    >
                      {EMAIL_TEMPLATE_TYPES.map((type) => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </select>
                    {s.errors.emailTemplateType && (
                      <span className="input-group-error">
                        {s.errors.emailTemplateType}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Subject</label>
                    <input
                      name="subject"
                      className={`form-control ${
                        s.errors.subject ? " !border-red-500" : ""
                      }`}
                      value={s.template.subject}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.subject && (
                      <span className="input-group-error">
                        {s.errors.subject}
                      </span>
                    )}
                  </div>
                  <div className="input-group col-span-2">
                    <label className="input-group-text">Template Data</label>
                    <textarea
                      name="templateData"
                      className={`form-control ${
                        s.errors.templateData ? " !border-red-500" : ""
                      }`}
                      value={s.template.templateData}
                      onChange={this.handleChange}
                      rows={4}
                      required
                    />
                    {s.errors.templateData && (
                      <span className="input-group-error">
                        {s.errors.templateData}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Active Status</label>
                    <select
                      name="activeStatus"
                      className={`form-control ${
                        s.errors.activeStatus ? " !border-red-500" : ""
                      }`}
                      value={s.template.activeStatus}
                      onChange={this.handleChange}
                      required
                    >
                      {ACTIVE_STATUS_OPTIONS.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.label}
                        </option>
                      ))}
                    </select>
                    {s.errors.activeStatus && (
                      <span className="input-group-error">
                        {s.errors.activeStatus}
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex justify-center gap-8 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-success">
                      Save
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                <div className="flex gap-2 mb-2 items-baseline justify-between">
                  <h3 className="font-bold">Configured Email Templates</h3>
                  <button
                    className="hover:font-bold flex gap-1 group"
                    onClick={() => this.handleEdit({})}
                  >
                    <i
                      className="bi bi-plus-circle group-hover:scale-105"
                      style={{ color: "black" }}
                    ></i>
                    Add
                  </button>
                </div>
                {s.emailTemplates.length === 0 ? (
                  <div className="text-gray-500">No email templates found.</div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50 sticky top-0">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Type
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Subject
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {s.emailTemplates.map((template, index) => {
                          const typeLabel =
                            EMAIL_TEMPLATE_TYPES.find(
                              (t) => t.value === template.emailTemplateType
                            )?.label || template.emailTemplateType;
                          return (
                            <tr key={index} className="hover:bg-gray-50">
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {template.id}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {typeLabel}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {template.subject}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {template.activeStatus}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                <button
                                  className="btn btn-success"
                                  onClick={() => this.handleEdit(template)}
                                >
                                  Edit
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
